import styled, { css } from 'styled-components'

export const AiSkeletonItemWrapper = styled.div<{ $blurBackground?: boolean }>`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  ${({ $blurBackground }) =>
    $blurBackground
      ? css`
          filter: blur(12px);
        `
      : undefined}
`

export const MediaItemLoadingRoot = styled.div<{ $isVisible: boolean }>`
  position: absolute;
  inset: 0;
  visibility: ${({ $isVisible }) => ($isVisible ? 'visible' : 'hidden')};
`

export const ScalableWrapper = styled.div<{
  $scale: number
  $canvasWidth: number
  $canvasHeight: number
}>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: ${({ $scale }) => `translate(-50%, -50%) scale(${$scale})`};
  transform-origin: center;
  background-color: black;
  width: ${({ $canvasWidth }) => $canvasWidth}px;
  height: ${({ $canvasHeight }) => $canvasHeight}px;
  z-index: 1;
  border-radius: ${({ $scale }) => `${8 / $scale}px`};

  /*make background transparent when skeleton has content */
  &:has(${AiSkeletonItemWrapper}:not(:empty)) {
    background-color: transparent;
  }
`

export const Canvas = styled.canvas`
  width: 100%;
  height: 100%;
`

export const CanvasWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
`

/** Sits inside GeneratingMediaCanvasOverlay; frame transform is applied on the CanvasItemFrame only. */
export const ImageInsideMediaFrame = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  cursor: pointer;
`
